import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Spacer from 'atoms/Spacer'
import Chip from 'atoms/Chip'

export default class ProposalDisabledEditor extends Component {
  static propTypes = {
    onProposalUpdate: PropTypes.func.isRequired,
  }

  handleClick = () => {
    const { onProposalUpdate } = this.props
    onProposalUpdate({ data: { disabled: false } })
  }

  render() {
    return (
      <Fragment>
        <Spacer />
        <Chip active onClick={this.handleClick}>
          Make active
        </Chip>
      </Fragment>
    )
  }
}
